export default __webpack_public_path__ + "static/media/AMM_dark_logo_centered.a327debd.png";